function isNask(extension: string): boolean {
  if (extension === "pl" || extension.endsWith(".pl")) {
    return true
  }

  return false
}

export default isNask
